import { takeLatest, takeEvery } from 'redux-saga/effects';
import * as types from '../constants/ActionTypes';
import {
  SEND_ROUTE_POINT_ENDINGS,
  isSendRoutePointEnding,
} from './route/routeConstants';
import {
  syncAddedRoutePoint,
  syncEditedRoutePoint,
  syncRemovedRoutePoint,
  sendRoutePoint,
} from './route/routePointSyncSaga';
import {
  addRoutePointWithEvent,
  renameRoutePointWithEvent,
} from './route/routeEventBoundSaga';

export {
  SEND_ROUTE_POINT_ENDINGS,
  isSendRoutePointEnding,
  syncAddedRoutePoint,
  syncEditedRoutePoint,
  syncRemovedRoutePoint,
  sendRoutePoint,
  addRoutePointWithEvent,
  renameRoutePointWithEvent,
};

export default function* watchRoute() {
  yield takeEvery(types.ADD_ROUTE_POINT_WITH_EVENT, addRoutePointWithEvent);
  yield takeEvery(
    types.RENAME_ROUTE_POINT_WITH_EVENT,
    renameRoutePointWithEvent
  );
  yield takeEvery(types.ADD_ROUTE_POINT, syncAddedRoutePoint);
  yield takeEvery(types.EDIT_ROUTE_POINT, syncEditedRoutePoint);
  yield takeEvery(types.REMOVE_ROUTE_POINT, syncRemovedRoutePoint);
  yield takeLatest(types.SEND_ROUTE_POINT, sendRoutePoint);
}
